// extracted by mini-css-extract-plugin
export default {"ZoomToolbar":"ZoomToolbar_ZoomToolbar__AAZ4g","ZoomToolbar__Percentage":"ZoomToolbar_ZoomToolbar__Percentage__FETut"};